import { createClient } from '@assetsJsModule/client/contact-form';

const client = createClient();

const sendContactForm = (
    name,
    email,
    subject,
    message,
    recipient,
    attachments,
) => client.save({
    name,
    email,
    subject,
    message,
    recipient,
    attachments,
});
export default sendContactForm;
